import {LoginView} from "./pages/login/view";

export const LoginPage = () => {
    return <LoginView />
}
